import React from 'react';
import { Card, Link, Text } from '@hz-design-system/web-ui';

import trackEvent from '../../../../utils/trackEvent';
import FeedItems from '../FeedItems';
import SearchPreviews from '../SearchPreviews';
import Listings from '../Listings';
import Classes from './Section.scss';
import { TFeedRequest, TPreviewBlock, TSearchRequest, TSection } from '../../../../types/TConfigurablePage';

type TProps = {
  section: TSection;
};

const trackSectionActionClick = (sectionTitle) => {
  trackEvent({ eventAction: 'ClickSectionAction', eventLabel: sectionTitle });
};

const Section = ({ section }: TProps) => (
  <div className={Classes.root}>
    <div className={Classes.titleWrapper}>
      <div className={Classes.title}>
        <h2 className="hz-Title hz-Title--title3">{section.body.title}</h2>
        {!!section.action && (
          <Link
            href={section.action.link}
            onClick={() => trackSectionActionClick(section.body.title)}
            className={Classes.cta}
          >
            {section.action.label}
          </Link>
        )}
      </div>
      {Boolean(section.body.description) && (
        <Text.Large className={Classes.description}>{section.body.description}</Text.Large>
      )}
    </div>
    <div className={Classes.content}>
      {section.type === 'feedItems' && (
        <FeedItems
          feedRequest={section.content.feedRequest as TFeedRequest}
          visualization={section.content.visualization}
        />
      )}
      {section.type === 'searchPreviews' && (
        <SearchPreviews
          previewBlocks={section.content.previewBlocks as TPreviewBlock[]}
          visualization={section.content.visualization}
        />
      )}
      {section.type === 'listings' && (
        <Listings
          searchRequest={section.content.searchRequest as TSearchRequest}
          visualization={section.content.visualization}
        />
      )}
      {section.type === 'seoContent' && (
        <Card className={Classes.seoContent}>
          {/*eslint-disable-next-line react/no-danger*/}
          <div dangerouslySetInnerHTML={{ __html: section.seoContent }} />
        </Card>
      )}
    </div>
  </div>
);

export default Section;
